import { Button } from '@coolremote/shared';
import { t } from 'ttag';
import useStyles from '../styles';

/**
 * Header row holding the discovery refresh trigger.
 * Only rendered when no discovery is in flight - while discovering,
 * DiscoveryProgress takes over the panel.
 *
 * @param {Object} props
 * @param {() => void} props.onRefresh - Callback to trigger discovery refresh
 * @param {boolean} [props.isLoading] - Whether the discover request is in flight
 * @returns {React.ReactElement}
 */
const Header = ({ onRefresh, isLoading = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.discoveringHeaderRow}>
      <div className={classes.headerRowSpacer} />
      <div className={classes.headerRowAction}>
        <Button
          variant="outlined"
          white
          onClick={onRefresh}
          size="small"
          disabled={isLoading}
        >
          {t`Discover`}
        </Button>
      </div>
    </div>
  );
};

export default Header;
